import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

// 🔥 همه درخواست‌ها فقط از یک origin
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [csrfToken, setCsrfToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---------------------------
  // گرفتن CSRF از بک‌اند
  // ---------------------------
  async function fetchCsrf() {
    const { data } = await axios.get('/csrf-token');
    setCsrfToken(data.csrfToken);
    return data.csrfToken;
  }

  // ---------------------------
  // وضعیت فعلی کاربر
  // ---------------------------
  async function fetchMe() {
    try {
      const { data } = await axios.get('/auth/me');
      setUser(data.user);
    } catch {
      setUser(null);
    }
  }

  // ---------------------------
  // LOGOUT — همیشه با CSRF تازه
  // ---------------------------
  async function logout() {
    try {
      // 1) همیشه قبل از logout یک CSRF تازه بگیر
      const freshToken = await fetchCsrf();

      // 2) ارسال logout با CSRF معتبر
      await axios.post(
        '/auth/logout',
        {},
        {
          headers: {
            'X-CSRF-Token': freshToken
          }
        }
      );

      // 3) پاک کردن user سمت فرانت
      setUser(null);
    } catch (e) {
      console.error('Logout failed', e);
    }
  }

  // ---------------------------
  // INIT — اول CSRF، بعد me
  // ---------------------------
  useEffect(() => {
    async function initAuth() {
      try {
        const token = await fetchCsrf();
        if (token) {
          await fetchMe();
        } else {
          setUser(null);
        }
      } catch (e) {
        console.error('Init auth failed', e);
        setUser(null);
      } finally {
        setLoading(false);
      }
    }

    initAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, csrfToken, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}


export function useAuth() {
  return useContext(AuthContext);
}
